import React from "react";
import { Routes, Route } from "react-router-dom";
import { userRoutes } from "./routes";

const UserRoutes = () => {
  return (
    <>
      <Routes>
        {
          userRoutes.map(({ path, element }, index)=>(
            <Route key={index} path={path} element={element} />
          ))
        }
      </Routes>
    </>
  );
};

export default UserRoutes;
